const conditionalQuestions = [
  {
    id: 1,
    koreanQuestion:
      "그녀가 (과거에) 탔더라면 더 일찍 비행기를, 그녀는 도착했을 것이다 제시간에 미팅에 ",
    question:
      "Had she taken the earlier flight, she ______ on time for the meeting.",
    choices: {
      A: "would arrive",
      B: "would have arrived",
      C: "had arrived",
      D: "arrives",
    },
    correctAnswer: "B",
    explanation:
      "가정법 과거완료 구문입니다. 'Had + 과거분사'로 시작하는 if절 생략 구문이며, 주절에는 'would have + 과거분사'를 사용합니다. 과거의 사실과 반대되는 상황을 가정할 때 이 형태를 씁니다.",
    translation:
      "그녀가 더 일찍 비행기를 탔더라면, 회의에 제시간에 도착했을 것이다.",
    type: "third conditional",
  },
  {
    id: 2,
    koreanQuestion:
      "회사가 더 나은 기술에 투자했더라면, 회사는 _______ 더 높은 시장 점유율을",
    question:
      "Had the company invested in better technology, it ______ a higher market share.",
    choices: {
      A: "would have gained",
      B: "gains",
      C: "is gaining",
      D: "has gained",
    },
    correctAnswer: "A",
    explanation:
      "가정법 과거완료 구문입니다. 'Had + 과거분사'로 시작하는 if절 생략 구문이며, 주절에는 'would have + 과거분사'를 사용합니다. 과거의 사실과 반대되는 상황을 가정할 때 이 형태를 씁니다.",
    translation:
      "회사가 더 나은 기술에 투자했더라면, 더 높은 시장 점유율을 얻었을 것이다.",
    type: "third conditional",
  },
  {
    id: 3,
    koreanQuestion:
      " 콜린스 씨가 보고서를 더 일찍 제출했더라면, 매니저는 _______ 검토할 추가 시간을",
    question:
      "Had Mr. Collins submitted his report earlier, the manager ______ additional time to review it.",
    choices: {
      A: "would have had",
      B: "has",
      C: "is having",
      D: "had",
    },
    correctAnswer: "A",
    explanation:
      "가정법 과거완료 구문입니다. 'Had + 과거분사'로 시작하는 if절 생략 구문이며, 주절에는 'would have + 과거분사'를 사용합니다. 과거의 사실과 반대되는 상황을 가정할 때 이 형태를 씁니다.",
    translation:
      "콜린스 씨가 보고서를 더 일찍 제출했더라면, 매니저는 검토할 추가 시간이 있었을 것이다.",
    type: "third conditional",
  },
  {
    id: 4,
    koreanQuestion:
      " 공급업체가 자재를 제때 배송했더라면, 생산은 _______ 계획대로",
    question:
      "Had the supplier shipped the materials on time, production ______ as planned.",
    choices: {
      A: "would have proceeded",
      B: "proceeds",
      C: "has proceeded",
      D: "is proceeding",
    },
    correctAnswer: "A",
    explanation:
      "가정법 과거완료 구문입니다. 'Had + 과거분사'로 시작하는 if절 생략 구문이며, 주절에는 'would have + 과거분사'를 사용합니다. 과거의 사실과 반대되는 상황을 가정할 때 이 형태를 씁니다.",
    translation:
      "공급업체가 자재를 제때 배송했더라면, 생산은 계획대로 진행되었을 것이다.",
    type: "third conditional",
  },
  {
    id: 5,
    koreanQuestion:
      " CEO가 제안을 승인했더라면, 프로젝트는 _______ 일정보다 앞서",
    question:
      "Had the CEO approved the proposal, the project ______ ahead of schedule.",
    choices: {
      A: "would have progressed",
      B: "progresses",
      C: "has progressed",
      D: "progressing",
    },
    correctAnswer: "A",
    explanation:
      "가정법 과거완료 구문입니다. 'Had + 과거분사'로 시작하는 if절 생략 구문이며, 주절에는 'would have + 과거분사'를 사용합니다. 과거의 사실과 반대되는 상황을 가정할 때 이 형태를 씁니다.",
    translation:
      "CEO가 제안을 승인했더라면, 프로젝트는 일정보다 앞서 진행되었을 것이다.",
    type: "third conditional",
  },
  {
    id: 6,
    koreanQuestion:
      "은행은 요구한다 모든 고객에게  _______ 보증금을 계좌를 개설하기 전에 ",
    question:
      "The bank requires that all customers ______ a deposit before opening an account.",
    choices: {
      A: "make",
      B: "makes",
      C: "made",
      D: "has made",
    },
    correctAnswer: "A",
    explanation:
      "가정법 현재 구문입니다. 'require that + 주어 + 동사원형'의 형태를 사용합니다. 'require that' 다음에는 동사의 원형을 써야 합니다.",
    translation:
      "은행은 모든 고객이 계좌를 개설하기 전에 보증금을 납부할 것을 요구한다.",
    type: "present subjunctive",
  },
  {
    id: 7,
    koreanQuestion:
      "필수적이다 매니저가 _______ 판매 수치를 이사회에 마감 기한 전까지 ",
    question:
      "It is essential that the manager ______ the sales figures to the board before the deadline.",
    choices: {
      A: "submits",
      B: "submit",
      C: "submitted",
      D: "has submitted",
    },
    correctAnswer: "B",
    explanation:
      "가정법 현재 구문입니다. 'It is essential that + 주어 + 동사원형'의 형태를 사용합니다. 가정법 현재에서는 that절의 동사를 원형으로 써야 합니다.",
    translation:
      "매니저가 판매 수치를 마감 기한 전까지 이사회에 제출하는 것이 필수적이다.",
    type: "present subjunctive",
  },
  {
    id: 8,
    koreanQuestion:
      "정책은 요구한다 지원자들이 _______ 보증금을 승인 후 24시간 이내에",
    question:
      "The policy demands that applicants ______ a deposit within 24 hours of approval.",
    choices: {
      A: "paid",
      B: "pays",
      C: "pay",
      D: "paying",
    },
    correctAnswer: "C",
    explanation:
      "가정법 현재 구문입니다. 'demand that + 주어 + 동사원형'의 형태를 사용합니다. 가정법 현재에서는 that절의 동사를 원형으로 써야 합니다.",
    translation:
      "정책은 지원자들이 승인 후 24시간 이내에 보증금을 납부할 것을 요구한다.",
    type: "present subjunctive",
  },
  {
    id: 9,
    koreanQuestion:
      "시장은 제안한다 주민들이 _______ 회의를 최근 이웃 분쟁을 해결하기 위해",
    question:
      "The mayor suggests that the residents ______ a meeting to address the recent neighborhood confrontation.",
    choices: {
      A: "hold",
      B: "holds",
      C: "held",
      D: "has held",
    },
    correctAnswer: "A",
    explanation:
      "가정법 현재 구문입니다. 'suggest that + 주어 + 동사원형'의 형태를 사용합니다. 가정법 현재에서는 that절의 동사를 원형으로 써야 합니다.",
    translation:
      "시장은 주민들이 최근 이웃 분쟁을 해결하기 위해 회의를 개최할 것을 제안한다.",
    type: "present subjunctive",
  },
  {
    id: 10,
    koreanQuestion:
      "그의 대안적 해결책이 없었다면, 협상은 _______ 실패했을 것이다",
    question:
      "Without his alternative solution, the negotiation ______ a failure.",
    choices: {
      A: "will be",
      B: "would have been",
      C: "was",
      D: "has been",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- Without + 명사는 If절 없이 가정법 과거완료를 나타냄\n- 과거 사실에 반대되는 상황을 가정\n- 따라서 would have been 사용\n\n💡 정답 B인 이유:\n- Without his solution = If he had not suggested his solution\n- 가정법 과거완료 형태로 표현\n- 주절에 would have been 사용\n\n💡 문법 포인트:\n- Without + 명사 = If it had not been for + 명사\n- 가정법 과거완료: would have + p.p.\n- 과거의 사실과 반대되는 상황을 가정할 때 사용",
    translation: "그의 대안적 해결책이 없었다면, 협상은 실패했을 것이다.",
    type: "conditional",
  },
  {
    id: 11,
    koreanQuestion:
      "그렇지 않았다면, 팀의 상대적 진행 상황이 _______ 지연되었을 것이다",
    question: "Otherwise, the team's relative progress ______ delayed.",
    choices: {
      A: "is",
      B: "would have been",
      C: "had been",
      D: "has been",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- Otherwise는 If절 없이 가정법 과거완료를 나타냄\n- 과거 사실에 반대되는 상황을 가정\n- 따라서 would have been 사용\n\n💡 정답 B인 이유:\n- Otherwise = If it had not been so\n- 가정법 과거완료 형태로 표현\n- 주절에 would have been 사용\n\n💡 문법 포인트:\n- Otherwise = If it had not been so/If not\n- 가정법 과거완료: would have + p.p.\n- 과거의 사실과 반대되는 상황을 가정할 때 사용",
    translation: "그렇지 않았다면, 팀의 상대적 진행 상황이 지연되었을 것이다.",
    type: "conditional",
  },
  {
    id: 12,
    koreanQuestion:
      "매니저가  _______ 일정 충돌에 대해 더 일찍, 우리는 미팅 일정을 조정할 수 있었을 것이다",
    question:
      "If the manager ______ about the schedule conflict earlier, we could reschedule the meeting.",
    choices: {
      A: "knows",
      B: "knew",
      C: "will know",
      D: "has known",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- 가정법 과거 구문\n- 현재 사실과 반대되는 상황을 가정\n- If절에 과거시제, 주절에 could 사용\n\n💡 정답 B인 이유:\n- 현재 매니저가 모르는 상황을 가정\n- 가정법 과거는 If + 과거시제 사용\n- 주절에 could를 사용하여 가능성 표현\n\n💡 문법 포인트:\n- 가정법 과거: If + 과거시제, 주절 would/could + 동사원형\n- 현재 사실과 반대되는 상황을 가정할 때 사용\n- could는 would보다 부드러운 표현",
    translation:
      "매니저가 일정 충돌에 대해 더 일찍 알았다면, 우리는 미팅 일정을 조정할 수 있었을 것이다.",
    type: "conditional",
  },
  {
    id: 13,
    koreanQuestion:
      "우리 지원팀이  _______  고객 문의에 더 빨리 , 우리의 만족도 평가가 훨씬 더 높을 것이다",
    question:
      "If our support team ______ customer inquiries faster, our satisfaction ratings would be much higher.",
    choices: {
      A: "answers",
      B: "answered",
      C: "has answered",
      D: "will answer",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- 가정법 과거 구문\n- 현재 사실과 반대되는 상황을 가정\n- If절에 과거시제, 주절에 would 사용\n\n💡 정답 B인 이유:\n- 현재 지원팀의 응답이 느린 상황을 가정\n- 가정법 과거는 If + 과거시제 사용\n- 주절에 would be 사용하여 결과 표현\n\n💡 문법 포인트:\n- 가정법 과거: If + 과거시제, 주절 would + 동사원형\n- 현재 사실과 반대되는 상황을 가정할 때 사용\n- would는 가정법에서 자주 사용되는 조동사",
    translation:
      "우리 지원팀이 고객 문의에 더 빨리 응답한다면, 우리의 만족도 평가가 훨씬 더 높을 것이다.",
    type: "conditional",
  },
  {
    id: 14,
    koreanQuestion:
      "개발팀이 _______ 테스트에 더 많은 시간을 , 제품의 결함이 더 적을 것이다",
    question:
      "If the development team ______ more time on testing, the product would have fewer defects.",
    choices: {
      A: "spends",
      B: "spent",
      C: "has spent",
      D: "spending",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- 가정법 과거 구문\n- 현재 사실과 반대되는 상황을 가정\n- If절에 과거시제, 주절에 would 사용\n\n💡 정답 B인 이유:\n- 현재 개발팀이 테스트에 충분한 시간을 투자하지 않는 상황을 가정\n- 가정법 과거는 If + 과거시제 사용\n- 주절에 would have를 사용하여 결과 표현\n\n💡 문법 포인트:\n- 가정법 과거: If + 과거시제, 주절 would + 동사원형\n- 현재 사실과 반대되는 상황을 가정할 때 사용\n- would는 가정법에서 자주 사용되는 조동사",
    translation:
      "개발팀이 테스트에 더 많은 시간을 투자한다면, 제품의 결함이 더 적을 것이다.",
    type: "conditional",
  },
  {
    id: 15,
    koreanQuestion:
      "내가 컴퓨터 공학을 전공했더라면, 지금 더 좋은 직업을 _______ .",
    question:
      "If I had majored in computer science, I ______ a better job now.",
    choices: {
      A: "will have",
      B: "would have",
      C: "would have had",
      D: "have",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- 혼합 가정법 구문: 과거 사실이 달랐다면, 현재가 달라졌을 것이다\n- 구조: If + 주어 + had p.p., 주어 + would + 동사원형\n- If절에 과거완료(had + p.p.), 주절에 would have 사용\n\n💡 정답 B인 이유:\n- 과거의 행동(전공 선택)이 현재에 미치는 영향을 가정\n- 'now'는 현재 시점을 나타냄\n- would have는 현재의 결과를 나타내는 데 적절\n\n💡 문법 포인트:\n- 혼합 가정법: If + 과거완료, 주절 would + 동사원형\n- 과거 사실이 달랐다면, 현재가 달라졌을 것이다\n- 과거의 행동이 현재에 미치는 영향을 표현할 때 사용",
    translation:
      "내가 컴퓨터 공학을 전공했더라면, 지금 더 좋은 직업을 가졌을 텐데.",
    type: "conditional",
  },
  {
    id: 16,
    koreanQuestion:
      "매니저는 제안했다 팀이 _______ 대체 전략을 다가오는 캠페인을 위한",
    question:
      "The manager suggested that the team ______ an alternative strategy for the upcoming campaign.",
    choices: {
      A: "develops",
      B: "develop",
      C: "developed",
      D: "developing",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- suggest that + 주어 + 동사원형 구문\n- 가정법 현재 구조\n- 제안하는 내용을 나타내는 that절 사용\n\n💡 정답 B인 이유:\n- suggest that 다음에는 동사 원형 사용\n- 팀이 수행해야 할 행동을 제안\n- 가정법 현재에서는 동사 원형 사용\n\n💡 문법 포인트:\n- suggest that + 주어 + 동사원형\n- 제안이나 요구를 나타낼 때 사용\n- that절에서는 동사 원형 사용",
    translation:
      "매니저는 팀이 다가오는 캠페인을 위한 대체 전략을 개발할 것을 제안했다.",
    type: "conditional",
  },
  {
    id: 17,
    koreanQuestion:
      "중요하다 모든 직원들이  _______ 보안 배지를 사무실 내에서 항상",
    question:
      "It is important that all employees ______ their security badges at all times within the office.",
    choices: {
      A: "wear",
      B: "wears",
      C: "wearing",
      D: "wore",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- It is important that + 주어 + 동사원형 구문\n- 가정법 현재 구조\n- 중요성을 나타내는 that절 사용\n\n💡 정답 A인 이유:\n- It is important that 다음에는 동사 원형 사용\n- 직원들이 수행해야 할 중요한 행동을 나타냄\n- 가정법 현재에서는 동사 원형 사용\n\n💡 문법 포인트:\n- It is important that + 주어 + 동사원형\n- 중요성이나 필요성을 나타낼 때 사용\n- that절에서는 동사 원형 사용",
    translation:
      "모든 직원들이 사무실 내에서 항상 보안 배지를 착용하는 것이 중요하다.",
    type: "conditional",
  },
  {
    id: 18,
    koreanQuestion: "이사는 추천했다 신입 직원들이 _______ 오리엔테이션 세션에",
    question:
      "The director recommended that new hires ______ an orientation session.",
    choices: {
      A: "attend",
      B: "to attend",
      C: "attends",
      D: "attending",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- recommend that + 주어 + 동사원형 구문\n- 가정법 현재 구조\n- 추천하는 내용을 나타내는 that절 사용\n\n💡 정답 A인 이유:\n- recommend that 다음에는 동사 원형 사용\n- 신입 직원들이 수행해야 할 행동을 추천\n- 가정법 현재에서는 동사 원형 사용\n\n💡 문법 포인트:\n- recommend that + 주어 + 동사원형\n- 추천이나 제안을 나타낼 때 사용\n- that절에서는 동사 원형 사용",
    translation:
      "이사는 신입 직원들이 오리엔테이션 세션에 참석할 것을 추천했다.",
    type: "conditional",
  },
  {
    id: 19,
    koreanQuestion: "회사가 필요하다 _______ 모든 국내 및 국제 안전 기준을.",
    question:
      "It is necessary that the company ______ with all local and international safety standards.",
    choices: {
      A: "complies",
      B: "comply",
      C: "complying",
      D: "complied",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- It is necessary that + 주어 + 동사원형 구문\n- 가정법 현재 구조\n- 필요성을 나타내는 that절 사용\n\n💡 정답 B인 이유:\n- It is necessary that 다음에는 동사 원형 사용\n- 회사가 수행해야 할 필요한 행동을 나타냄\n- 가정법 현재에서는 동사 원형 사용\n\n💡 문법 포인트:\n- It is necessary that + 주어 + 동사원형\n- 필요성이나 요구사항을 나타낼 때 사용\n- that절에서는 동사 원형 사용",
    translation: "회사가 모든 국내 및 국제 안전 기준을 준수하는 것이 필요하다.",
    type: "conditional",
  },
  {
    id: 20,
    koreanQuestion:
      "CEO는 주장했다 각 부서가 _______ 성과 평가를 회계연도 종료 전에",
    question:
      "The CEO insisted that each department ______ a performance review before the end of the fiscal year.",
    choices: {
      A: "conducts",
      B: "conduct",
      C: "conducting",
      D: "conducted",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- insist that + 주어 + 동사원형 구문\n- 가정법 현재 구조\n- 주장하는 내용을 나타내는 that절 사용\n\n💡 정답 B인 이유:\n- insist that 다음에는 동사 원형 사용\n- 각 부서가 수행해야 할 행동을 주장\n- 가정법 현재에서는 동사 원형 사용\n\n💡 문법 포인트:\n- insist that + 주어 + 동사원형\n- 주장이나 요구를 나타낼 때 사용\n- that절에서는 동사 원형 사용",
    translation:
      "CEO는 각 부서가 회계연도 종료 전에 성과 평가를 실시할 것을 주장했다.",
    type: "conditional",
  },
  {
    id: 21,
    koreanQuestion:
      "새 규정은 요구한다 모든 방문객들에게 _______ 접수처에서 건물에 들어가기 전에",
    question:
      "The new regulations require that all visitors ______ in at the reception before entering the building.",
    choices: {
      A: "check",
      B: "checks",
      C: "checking",
      D: "checked",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- require that + 주어 + 동사원형 구문\n- 가정법 현재 구조\n- 요구사항을 나타내는 that절 사용\n\n💡 정답 A인 이유:\n- require that 다음에는 동사 원형 사용\n- 방문객들이 수행해야 할 필수 행동을 나타냄\n- 가정법 현재에서는 동사 원형 사용\n\n💡 문법 포인트:\n- require that + 주어 + 동사원형\n- 요구사항이나 규정을 나타낼 때 사용\n- that절에서는 동사 원형 사용",
    translation:
      "새 규정에 따라 모든 방문객은 건물에 들어가기 전에 접수처에서 체크인해야 한다.",
    type: "conditional",
  },
  {
    id: 22,
    koreanQuestion:
      "권장된다 직원들은 _______ 비상 대피 경로를 정기적으로 대비를 위해",
    question:
      "It is advised that employees ______ emergency exit routes regularly to ensure preparedness.",
    choices: {
      A: "review",
      B: "reviews",
      C: "reviewing",
      D: "reviewed",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- It is advised that + 주어 + 동사원형 구문\n- 가정법 현재 구조\n- 권고사항을 나타내는 that절 사용\n\n💡 정답 A인 이유:\n- It is advised that 다음에는 동사 원형 사용\n- 직원들이 수행해야 할 권장 행동을 나타냄\n- 가정법 현재에서는 동사 원형 사용\n\n💡 문법 포인트:\n- It is advised that + 주어 + 동사원형\n- 권고나 조언을 나타낼 때 사용\n- that절에서는 동사 원형 사용",
    translation:
      "직원들이 대비를 위해 비상 대피 경로를 정기적으로 점검하는 것이 권장된다.",
    type: "conditional",
  },
  {
    id: 23,
    koreanQuestion:
      "감독관이 명령했다 모든 팀장들이 _______ 진행 보고서를 금요일 오후까지",
    question:
      "The supervisor ordered that all team leaders ______ their progress reports by Friday afternoon.",
    choices: {
      A: "submits",
      B: "submit",
      C: "submitting",
      D: "submitted",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- order that + 주어 + 동사원형 구문\n- 가정법 현재 구조\n- 명령을 나타내는 that절 사용\n\n💡 정답 B인 이유:\n- order that 다음에는 동사 원형 사용\n- 팀장들이 수행해야 할 필수 행동을 나타냄\n- 가정법 현재에서는 동사 원형 사용\n\n💡 문법 포인트:\n- order that + 주어 + 동사원형\n- 명령이나 지시를 나타낼 때 사용\n- that절에서는 동사 원형 사용",
    translation:
      "감독관은 모든 팀장이 금요일 오후까지 진행 보고서를 제출할 것을 명령했다.",
    type: "conditional",
  },
  {
    id: 24,
    koreanQuestion:
      "가장 좋다 회사가 _______ 외부 컨설턴트를 최종 결정을 내리기 전에",
    question:
      "It is best that the company ______ an external consultant before making a final decision.",
    choices: {
      A: "hires",
      B: "hire",
      C: "hiring",
      D: "hired",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- It is best that + 주어 + 동사원형 구문\n- 가정법 현재 구조\n- 최선의 선택을 나타내는 that절 사용\n\n💡 정답 B인 이유:\n- It is best that 다음에는 동사 원형 사용\n- 회사가 취해야 할 최선의 행동을 나타냄\n- 가정법 현재에서는 동사 원형 사용\n\n💡 문법 포인트:\n- It is best that + 주어 + 동사원형\n- 최선의 선택이나 권장사항을 나타낼 때 사용\n- that절에서는 동사 원형 사용",
    translation:
      "회사가 최종 결정을 내리기 전에 외부 컨설턴트를 고용하는 것이 가장 좋다.",
    type: "conditional",
  },
  {
    id: 25,
    koreanQuestion: "요청된다 모든 송장이 처리되도록 수령 후 48시간 이내에",
    question:
      "It is requested that all invoices ______ processed within 48 hours of receipt.",
    choices: {
      A: "is",
      B: "are",
      C: "be",
      D: "being",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- It is requested that + 주어 + be + 과거분사 구문\n- 가정법 현재 구조\n- 요청사항을 나타내는 that절 사용\n\n💡 정답 C인 이유:\n- It is requested that 다음에는 be 동사 사용\n- 수동태 구문에서 be동사가 필요\n- 가정법 현재에서는 be 사용\n\n💡 문법 포인트:\n- It is requested that + 주어 + be + 과거분사\n- 공식적인 요청을 나타낼 때 사용\n- that절에서는 be 사용",
    translation: "모든 송장이 수령 후 48시간 이내에 처리되도록 요청된다.",
    type: "conditional",
  },
  {
    id: 26,
    koreanQuestion:
      "내가 어제 일찍 잤더라면, 오늘 회의에서 _______ 더 집중할 수 있을 텐데",
    question:
      "If I had gone to bed early yesterday, I ______ focus better in today's meeting.",
    choices: {
      A: "can",
      B: "could",
      C: "will be able to",
      D: "would be able to",
    },
    correctAnswer: "D",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- 혼합 가정법 구문\n- 과거 사실이 현재에 미치는 영향을 표현\n- If절은 과거완료, 주절은 현재 시점의 결과\n\n💡 정답 D인 이유:\n- 과거의 행동(어제 일찍 자기)이 현재(오늘 회의)에 미치는 영향\n- would be able to는 현재 시점의 가능성을 나타냄\n- 혼합 가정법에서 현재 결과를 나타낼 때 적절\n\n💡 문법 포인트:\n- 혼합 가정법: If + 과거완료, 주절 would + 동사원형\n- 과거 행동의 현재 영향을 표현\n- would be able to는 현재 가능성을 나타냄",
    translation:
      "내가 어제 일찍 잤더라면, 오늘 회의에서 더 집중할 수 있었을 텐데.",
    type: "mixed conditional",
  },
  {
    id: 27,
    koreanQuestion:
      "그가 더 많은 경험이 있었더라면, 지금 이 프로젝트를 _______ 더 잘 관리할 수 있을 텐데",
    question:
      "If he had had more experience, he ______ manage this project better now.",
    choices: {
      A: "could have",
      B: "would have",
      C: "would",
      D: "could",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- 혼합 가정법 구문\n- 과거의 경험 부족이 현재 상황에 미치는 영향\n- If절은 과거완료, 주절은 현재 시점의 결과\n\n💡 정답 C인 이유:\n- 과거의 상황(경험 부족)이 현재(프로젝트 관리)에 미치는 영향\n- would는 현재 시점의 가능성을 나타냄\n- 'now'가 있어 현재 상황임을 알 수 있음\n\n💡 문법 포인트:\n- 혼합 가정법: If + 과거완료, 주절 would + 동사원형\n- 과거 상황이 현재에 미치는 영향을 표현\n- would + 동사원형은 현재의 결과를 나타냄",
    translation:
      "그가 더 많은 경험이 있었더라면, 지금 이 프로젝트를 더 잘 관리할 수 있을 텐데.",
    type: "mixed conditional",
  },
  {
    id: 28,
    koreanQuestion:
      "그가 지난달에 승진했더라면, 지금쯤 새로운 프로젝트를 _______ 진행하고 있었을 텐데",
    question:
      "Had he been promoted last month, he ______ working on the new project by now.",
    choices: {
      A: "would be",
      B: "would have been",
      C: "will be",
      D: "had been",
    },
    correctAnswer: "A",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- 혼합 가정법 구문\n- Had + 과거분사로 시작하는 도치 구문 사용\n- 과거 사실이 현재 진행 상황에 미치는 영향\n\n💡 정답 A인 이유:\n- 과거의 상황(승진)이 현재 진행형 상태에 미치는 영향\n- would be + ~ing는 현재 진행 중일 가능성을 나타냄\n- 'by now'는 현재 시점을 나타내므로 would be가 적절\n\n💡 문법 포인트:\n- 혼합 가정법: Had + 과거분사, would + be + ~ing\n- 도치 구문으로 if 생략 가능\n- 현재 진행 상태를 나타내는 would be + ~ing 구문",
    translation:
      "그가 지난달에 승진했더라면, 지금쯤 새로운 프로젝트를 진행하고 있었을 텐데.",
    type: "mixed conditional",
  },
  {
    id: 29,
    koreanQuestion:
      "우리가 작년에 그 기술을 도입했더라면, 지금쯤 경쟁사들이 우리를 _______ 따라잡으려고 노력하고 있었을 것이다",
    question:
      "Were we to have implemented that technology last year, our competitors ______ trying to catch up with us now.",
    choices: {
      A: "will be",
      B: "would have been",
      C: "would be",
      D: "might have been",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- 혼합 가정법 구문\n- Were + 주어 + to have + 과거분사 형태의 고급 도치 구문\n- 과거 가정이 현재에 미치는 영향\n\n💡 정답 C인 이유:\n- 과거의 행동(기술 도입)이 현재 상황에 미치는 영향\n- would be + ~ing는 현재 진행 중일 가능성을 나타냄\n- 'now'가 있어 현재 시점임을 알 수 있음\n\n💡 문법 포인트:\n- Were + 주어 + to have + 과거분사 (고급 도치 구문)\n- 혼합 가정법에서 현재 진행 상태를 나타내는 would be + ~ing\n- 공식적이고 격식 있는 표현",
    translation:
      "우리가 작년에 그 기술을 도입했더라면, 지금쯤 경쟁사들이 우리를 따라잡으려고 노력하고 있었을 것이다.",
    type: "mixed conditional",
  },
  {
    id: 30,
    koreanQuestion:
      "그 투자자들이 우리의 제안을 받아들였더라면, 우리는 지금쯤 해외 시장으로 _______ 확장하고 있었을 텐데",
    question:
      "Had the investors accepted our proposal, we ______ expanding into foreign markets by now.",
    choices: {
      A: "will have been",
      B: "would have been",
      C: "would be",
      D: "might have",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- 혼합 가정법 구문\n- Had + 과거분사로 시작하는 도치 구문\n- 과거 결정이 현재 진행 상황에 미치는 영향\n\n💡 정답 C인 이유:\n- 과거의 상황(제안 수락)이 현재 진행형 상태에 미치는 영향\n- would be + ~ing는 현재 진행 중일 가능성을 나타냄\n- 'by now'는 현재 시점을 나타내므로 would be가 적절\n\n💡 문법 포인트:\n- 도치된 혼합 가정법: Had + 과거분사, would be + ~ing\n- 현재 진행 상태를 나타내는 would be + ~ing 구문\n- 비즈니스 상황에서의 가정법 사용",
    translation:
      "그 투자자들이 우리의 제안을 받아들였더라면, 우리는 지금쯤 해외 시장으로 확장하고 있었을 텐데.",
    type: "mixed conditional",
  },
  {
    id: 31,
    koreanQuestion:
      "구독을 취소하고 싶으시면, 최소 7일 전에 요청을 제출해 주세요.",
    question:
      "_____ you wish to cancel your subscription, please submit a request at least 7 days in advance.",
    choices: {
      A: "Were",
      B: "Should",
      C: "Unless",
      D: "Since",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- Should를 사용한 조건문\n- 공식적인 상황에서의 조건 표현\n- 정중한 요청/안내 표현\n\n💡 정답 B인 이유:\n- Should는 'if'의 더 격식 있는 표현\n- 공식적인 안내문에 적합\n- 가능성 있는 미래 상황을 가정\n\n💡 오답 분석:\n- Were: 'Were you to wish'형태로 써야 맞음\n- Unless: '~하지 않는다면'의 의미로 부적절\n- Since: '~이므로'라는 의미로 조건문 맥락과 맞지 않음\n\n💡 문법 포인트:\n- Should + 주어 + 동사원형\n- 공식적인 조건문 표현\n- 비즈니스 문서나 안내문에 자주 사용",
    translation:
      "구독을 취소하고 싶으시면, 최소 7일 전에 요청을 제출해 주세요.",
    type: "conditional",
  },
  {
    id: 32,
    koreanQuestion:
      "추가 지원이 필요하시면, 저희 지원팀이 기꺼이 도와드리겠습니다.",
    question:
      "_____ you require further assistance, our support team will be happy to help.",
    choices: {
      A: "Were",
      B: "Should",
      C: "Unless",
      D: "Given",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- Should를 사용한 조건문\n- 공식적인 상황에서의 조건 표현\n- 정중한 서비스 제공 표현\n\n💡 정답 B인 이유:\n- Should는 'if'의 더 격식 있는 표현\n- 고객 서비스 상황에 적합한 공식적 어조\n- 가능성 있는 미래 상황을 가정\n\n💡 오답 분석:\n- Were: 'Were you to require'형태로 써야 맞음\n- Unless: '~하지 않는다면'의 부정적 의미로 부적절\n- Given: '~을 고려하면'의 의미로 조건문 맥락과 맞지 않음\n\n💡 문법 포인트:\n- Should + 주어 + 동사원형\n- 공식적인 조건문 표현\n- 고객 서비스 상황에서 자주 사용되는 정중한 표현",
    translation:
      "추가 지원이 필요하시면, 저희 지원팀이 기꺼이 도와드리겠습니다.",
    type: "conditional",
  },
];

export default conditionalQuestions;
